// removed by extract-text-webpack-plugin
module.exports = {"integrationLander":"integrationLander---1Nqm_"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/slack-lander.styl
// module id = /ub6
// module chunks = 89